import Mutations from '../../odata/mutations';

export default { ...new Mutations('documentTemplate'), ...new Mutations('documentTemplates') };
